import {Button, Modal} from "react-bootstrap";
import {useState, useRef, useEffect} from "react";
import arrayUtilities from "../../utilities/arrayUtilities";
import stringHelpers from "../../utilities/stringHelpers";
import Enums from "../../utilities/enum";
import formUtilities from "../../utilities/formUtilities";
import { getOrdinalDayOfMonth } from "../../utilities/dateUtilities";
export const ScheduleExportModal = ({children, initialValues, onCancel, onSubmit, disableConfirm=false, errorMessage = null, reportType = null}) => {
    const [scheduleName, setScheduleName] = useState(reportType !== null ? `${Enums.ReportType[reportType]} report` : "");
    const [isActive, setIsActive] = useState(true)
    const [scheduleFrequencyMode, setScheduleFrequencyMode] = useState(0)
    const [dayOfMonth, setDayOfMonth] = useState(1)
    const [days, setDays] = useState({
        monday: {
            label: "Monday",
            isEnabled: false
        },
        tuesday: {
            label: "Tuesday",
            isEnabled: false,
        },
        wednesday: {
            label: "Wednesday",
            isEnabled: false,
        },
        thursday: {
            label: "Thursday",
            isEnabled: false,
        },
        friday: {
            label: "Friday",
            isEnabled: false,         
        },
        saturday: {
            label: "Saturday",
            isEnabled: false,
        },
        sunday: {
            label: "Sunday",
            isEnabled: false,
        }
    })
    const [sendTime, setSendTime] = useState("00:00")
    const [recipients, setRecipients] = useState([])
    const [newRecipient, setNewRecipient] = useState("")
    const [editIndex, setEditIndex] = useState(null)
    const [showRecipientsValidation, setShowRecipientsValidation] = useState(false)
    const [unsavedRecipient, setUnsavedRecipient] = useState(false)

    useEffect(() => {
        if (stringHelpers.isNullOrEmpty(newRecipient)) {
            setUnsavedRecipient(false)
        }
    }, [newRecipient])
    const recipientInputRef = useRef(null);

    const handleContinueEditing = () => {
        setUnsavedRecipient(false)
        recipientInputRef.current?.focus()
    }

    useEffect(() => {
        if (!initialValues) {
            return
        }
        setScheduleName(initialValues.name)
        setIsActive(initialValues.isActive)
        setDayOfMonth(Number(initialValues.dayOfMonth ?? 1))
        setScheduleFrequencyMode(initialValues.frequency)
        setDays(prevState => (
            Object
            .keys(prevState)
            .reduce(
                (acc, key) => {
                    acc = {
                        ...acc,
                        [key]: {
                            ...prevState[key],
                            isEnabled: initialValues[key]
                        }
                    }
                    return acc
                }, {}
            )
        ))
        setSendTime(!stringHelpers.isNullOrEmpty(initialValues.sendTime) ? initialValues.sendTime.slice(0, 5) : "00:00")
        setRecipients(initialValues.recipients)
        
    }, [initialValues])

    const hasErrorMessage = !stringHelpers.isNullOrEmpty(errorMessage)
    const hasFooterMessage = hasErrorMessage || unsavedRecipient

    return (
        <Modal size="lg" show onClose={onCancel} className="tag-selector-scroll-container">
            <Modal.Header>
                <Modal.Title>Schedule Report {reportType !== null && <>- {Enums.ReportType[reportType]}</>}</Modal.Title>
                <Button variant="default" onClick={onCancel}><i className="fa fa-times"></i></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="row mb-2">
                    <div className="col-3 d-flex align-items-center">
                        <h5 className="m-0">Name</h5>
                    </div>
                    <div className="col-9">
                        <input
                            required
                            className="form-control w-100"
                            value={scheduleName}
                            type="text"
                            onChange={(e) => {
                                formUtilities.requiredField(e.target.parentNode, e.target.value)
                                setScheduleName(e.target.value)
                            }}
                        />
                        <small className='invalid-feedback text-danger'>Please enter a name</small>
                    </div>
                </div>
                <hr className="border-dashed border-bottom-0"></hr>
                {children}

                <div>
                    <h5 className="mb-2">Schedule</h5>

                    <div className="row mb-2">
                        <div className="col-md-3">Enabled</div>
                        <div className="col-md-9 custom-control custom-switch">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="schedule-export-enable-switch"
                                checked={ isActive }
                                onChange={e => setIsActive(e.target.checked)}
                            />
                            <label className="custom-control-label custom-toggle ml-3" htmlFor="schedule-export-enable-switch"></label>
                            <p className="m-0 ml-3">{isActive ? <>Yes</> : <>No</>}</p>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-3">Frequency</div>
                        <div className="col-md-9 d-flex">
                            {
                                Object
                                    .entries(Enums.ScheduleFrequencyMode)
                                    .map(
                                        ([key, label]) => <div key={key} className="d-flex align-items-center mr-3">
                                            <input value={key} checked={scheduleFrequencyMode === Number(key)} onClick={() => setScheduleFrequencyMode(Number(key))} type="radio" id={`export-${label.toLowerCase()}`} name="export-frequency-radio" />
                                            <label className='m-0 ml-1' htmlFor={`export-${label.toLowerCase()}`}>{label}</label>
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                    
                    {
                        scheduleFrequencyMode === 1 && Object.entries(days).map(([day, value]) => (<div key={day} className="row mb-2">
                        <div className="col-md-3 mt-1">{value.label}</div>
                        <div className="col-md-6 col-12 custom-control custom-switch">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id={ `${ value.label }-${ day }-enable-switch` }
                                checked={ value.isEnabled }
                                onChange={
                                    e => setDays(prevState => (
                                        {
                                            ...prevState,
                                            [day]: {
                                                ...prevState[day],
                                                isEnabled: e.target.checked
                                            }
                                        }
                                    )
                                    )
                                }
                            />
                            <label className="custom-control-label ml-3" htmlFor={`${value.label}-${day}-enable-switch`}></label>
                            <p className="m-0 ml-3 mt-1">{value.isEnabled ? <>Yes</> : <>No</>}</p>
                        </div>
                        </div>))
                    }

                    {
                        scheduleFrequencyMode === 2 &&                        
                        <div className="row">
                            <div className="col-md-3 mt-1">
                                Day of month
                            </div>
                            <div className="col-md-9">
                                <select className="form-control" value={String(dayOfMonth)} onChange={e => setDayOfMonth(Number(e.target.value))}>
                                    {
                                        Array
                                        .from({length: 31}, (_, index) => index + 1)
                                        .map(item => <option key={item} selected={item === dayOfMonth} value={String(item)}>{getOrdinalDayOfMonth(item)}</option>)
                                    }
                                </select>
                            </div>
                        </div>
                    }

                    
                    <div className="row my-2">
                        <div className="col-md-3 d-flex align-items-center">Time</div>
                        <div className="col-md-9">
                            <input value={sendTime} className="rounded form-control" type="time" onChange={e => setSendTime(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <hr className="border-dashed border-bottom-0"></hr>
                <div>
                    <div className="row mb-2">
                        <div className="col-md-3 d-flex pt-2">
                            <h5 className="m-0">Recipients</h5>
                        </div>
                        <div className="col-md-9">
                            <form
                                className="d-flex align-items-center border rounded bg-white mb-1"
                                onSubmit={e => {
                                    e.preventDefault()
                                    setShowRecipientsValidation(false)
                                    if ( editIndex !== null && editIndex > -1 ) {
                                        const newArray = recipients.toSpliced(editIndex,1,newRecipient)
                                        setRecipients(newArray)
                                    } else {
                                        setRecipients(prevState => [...prevState,newRecipient])
                                    }
                                    setNewRecipient("")
                                    setEditIndex(null)
                                }}
                            >
                                <input
                                    ref={recipientInputRef}
                                    className="form-control border-0 w-100 outline-none"
                                    value={newRecipient}
                                    type="text"
                                    placeholder="Enter value"
                                    onChange={(e) => setNewRecipient(e.target.value)}
                                />
                                <button
                                    type="submit"
                                    style={{ height: "36px",borderLeft: "1px solid #d8e2ef",borderRadius: 0, borderTopRightRadius: "4px", borderBottomRightRadius: "4px" }}
                                    className={`btn btn-sm bg-${!stringHelpers.isNullOrEmpty(newRecipient) ? "primary" : "none"} py-0 px-3`}
                                    disabled={stringHelpers.isNullOrEmpty(newRecipient)}
                                >
                                    <i className={`fas fa-check text-${!stringHelpers.isNullOrEmpty(newRecipient) ? "white" : "secondary"}`}></i>
                                </button>
                            </form>
                            {
                                showRecipientsValidation && <div>
                                    <small className="text-danger m-0">Please enter a recipient</small>
                                </div>
                            }
                            <div className="flex-wrap mt-1" style={{ display: "flex",gap: "8px" }}>
                                {
                                    !arrayUtilities.isNullOrEmpty(recipients) 
                                    && recipients.map((recipient,index) => (<div key={index} className="badge badge-secondary d-flex align-items-center text-white p-0 mw-100">
                                    <button disabled={index === editIndex} type="button" onClick={() => {
                                        setNewRecipient(recipient)
                                        setEditIndex(index)
                                        if ( recipientInputRef.current ) {
                                            recipientInputRef.current.focus()
                                        }
                                    }} className="btn btn-none btn-sm m-0 d-flex align-items-center px-2">
                                        <p className="text-white fs--1 m-0 text-left" style={{ whiteSpace: "normal", wordBreak: "break-all" }}>{recipient}</p>
                                    </button>
                                    {index === editIndex
                                        ? <>
                                            <button onClick={() => {
                                                setEditIndex(null)
                                                setNewRecipient("")
                                            }} type="button" className="btn btn-none btn-sm m-0 p-0 py-2 px-2 border-left">
                                                <i className="fas fa-undo text-white m-0 p-0"></i>
                                            </button>
                                        </> : <button onClick={() => {
                                            const newArray = recipients.filter((_,i) => i !== index)
                                            setRecipients(newArray)
                                            if (arrayUtilities.isNullOrEmpty(newArray)) {
                                                setShowRecipientsValidation(true)
                                            }
                                            if ( editIndex !== null ) {
                                                if ( index === editIndex ) {
                                                    setNewRecipient("")
                                                    setEditIndex(null)
                                                } else if ( index < editIndex ) {
                                                    setEditIndex(editIndex - 1)
                                                }
                                            }
                                        }} type="button" className="btn btn-none btn-sm m-0 p-0 py-2 px-2 border-left">
                                            <i className="fas fa-times text-white m-0 p-0"></i>
                                        </button>}
                                </div>))}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    hasFooterMessage &&
                    <div className="d-flex flex-column" style={{ flex: "1 1 0", minWidth: 0 }}>
                        { hasErrorMessage && <small className="text-danger"><i className="fas fa-exclamation-triangle mr-1"></i>{ errorMessage }</small> }
                        { unsavedRecipient && <small className="text-warning"><i className="fas fa-exclamation-triangle mr-1"></i>You have an unsaved recipient. Press <i className="fas fa-check"></i> to add <strong className="d-inline-block text-truncate align-bottom" style={{ maxWidth: "160px" }}>{newRecipient}</strong>, or save without it.</small> }
                    </div>
                }
                {
                    unsavedRecipient
                        ? <Button variant="outline-secondary" size="sm" onClick={ handleContinueEditing }>Continue editing</Button>
                        : <Button variant="outline-secondary" size="sm" onClick={ onCancel }>Cancel</Button>
                }
                <Button
                    size="sm"
                    variant="success"
                    disabled={ stringHelpers.isNullOrEmpty(scheduleName) || arrayUtilities.isNullOrEmpty(recipients) || disableConfirm }
                    onClick={ () => {
                        if (!stringHelpers.isNullOrEmpty(newRecipient) && !unsavedRecipient) {
                            setUnsavedRecipient(true)
                        } else {
                            setUnsavedRecipient(false)
                            onSubmit(
                                isActive,
                                scheduleName,
                                scheduleFrequencyMode,
                                days.monday.isEnabled,
                                days.tuesday.isEnabled,
                                days.wednesday.isEnabled,
                                days.thursday.isEnabled,
                                days.friday.isEnabled,
                                days.saturday.isEnabled,
                                days.sunday.isEnabled,
                                dayOfMonth,
                                `${ sendTime }:00`,
                                recipients
                            )
                        }
                    } }
                >
                    {
                        unsavedRecipient ? <>Save without it</> : <>Save</>
                    }
                </Button>
            </Modal.Footer>
        </Modal>)
}